export default "__VITE_ASSET__8TYz$5n9__"